<template>
<!-- eslint-disable vue/valid-v-slot -->
<v-container class="white a4width black--text">
    <v-btn class="d-print-none"
        style="float: right;"
        elevation="4" right
        tile outlined color="success"
        @click="printPage()"
        ripple>
        <v-icon left>mdi-printer</v-icon> {{$t('Print')}}
    </v-btn>
    <v-btn class="d-print-none"
        style="float: right;"
        elevation="4" right
        tile outlined color="success"
        @click="$router.go(-1)"
        ripple>
        <v-icon left>mdi-arrow-left</v-icon> {{$t('Back')}}
    </v-btn>
    <printHeader class="d-print-flex mt-n10" v-bind:subtitle="''"></printHeader>
    <v-row>
      <v-col cols="7">
        <span class="display-1 mx-12 border">{{recipe.code}} - {{recipe.name}}</span>
      </v-col>
      <v-col cols="3">
        <span v-if="recipe.archive">Archived</span>
      </v-col>
    </v-row>
    <v-row class="mx-4">
      <v-col cols="4">
        <span class="font-weight-medium">Recipe Source: </span>
        <span class="field-data">{{recipe.source}}</span>
      </v-col>
      <v-col cols="4">
        <span class="font-weight-medium">Target Group: </span>
        <span class="field-data">{{recipe.translatedTargetGroup}}</span>
      </v-col>
    </v-row>
     <v-data-table
      :headers="headers"
      :items="recipe.nutrition"
      :items-per-page="30"
      dense
      class="headline pt-4 mx-8 white black--text"
      hide-default-footer
      hide-default-header
      fixed-header
    >
    <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th
              v-for="hdr in headers"
              :key="hdr.index"
              class="subtitle-2 white black--text table-heading"
              :class="{
                'text-end': hdr.align == 'end',
                'text-center': hdr.align == 'center',
                'ps-6': hdr.value == 'consider',
              }"
            >
              {{ hdr.text.toUpperCase() }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item.consider="{ item }">
        <span class="ps-5 py-0 black--text">
          <v-icon color="black" dense v-if="item.consider">mdi-check</v-icon>
        </span>
      </template>
    </v-data-table>
</v-container>

</template>
<script>
import printHeader from "../components/common/PrintHeader";
export default {
    name: "RecipePrint",
    components: {
        printHeader
    },
    data() {
        return {
          recipeId: this.$route.params.id,
          headers: [
              { text: this.$i18n.t("Use"),  align: "start",  sortable: false,  width: "8%",  value: "consider",  class: "table-header-class"},
              { text: this.$i18n.t("Nutrition"),  align: "start",  sortable: true,  width: "30%",  value: "name",  class: "table-header-class"},
              { text: this.$i18n.t("Unit"),  align: "start",  sortable: false,  width: "8%",  value: "unit",  class: "table-header-class"},
              { text: this.$i18n.t("Minimum"),  align: "end",  sortable: false,  width: "17%",  value: "min",  class: "table-header-class"},
              { text: this.$i18n.t("Maximum"),  align: "end",  sortable: false,  width: "17%",  value: "max",  class: "table-header-class"}
          ],
        }
    },
    computed: {
      recipe() {
        return this.$store.getters.getRecipe(this.recipeId);
      }
    },
    methods: {
      printPage() {
        let saveDrawer = this.$store.getters.getDrawerState;
        this.$store.dispatch("setDrawerState", false);
        this.$nextTick(() => {
          window.print();
          this.$store.dispatch("setDrawerState", saveDrawer);
        });
      }
   }
}
</script>

<style scoped>
@media print {
  @page {
    size: A4;
  }
}

.a4width {
    /* size: 21cm 29.7cm; */
    size: portrait;
    padding: 0 !important;
    margin: 0;
}
.table-heading {
  text-decoration: underline;
  font-weight: medium;
}
.field-data {
  border-bottom: 1px solid black;
  padding-left: 3px;
  padding-right: 60px;
}

</style>